import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LoadingDots from '../ds/components/LoadingDots';
import MarcoMarca from './MarcoMarca';

// Pantalla de transición hacia la vista previa de la web. Solo existe el recorrido de la web
// (las ideas de app y el diagnóstico de una web existente se sacaron de la home el 18/10/2026).
const getSequence = (passState = {}) => {
  const nombre = passState.businessName ? `${passState.businessName}` : null;
  return [
    nombre ? `Leyendo lo que contaste sobre ${nombre}...` : 'Mirando lo que contaste...',
    'Pensando cómo se vería tu web...',
    nombre ? `Buscando qué mejor representa a ${nombre}...` : 'Pensando en lo que mejor te representa...',
    'Preparando tu espacio...',
  ];
};

const GuiaLoading = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dest      = state?.dest || '/dashboard';
  const passState = useMemo(() => state?.passState || {}, [state]);
  const steps     = useMemo(() => getSequence(passState), [passState]);

  const [stepIdx, setStepIdx] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [barWidth, setBarWidth] = useState(0);
  const [done, setDone] = useState(false);

  // Escribe el paso actual
  useEffect(() => {
    const text = steps[stepIdx];
    let i = 0;
    setDisplayText('');
    const iv = setInterval(() => {
      i++;
      setDisplayText(text.slice(0, i));
      if (i >= text.length) clearInterval(iv);
    }, 28);
    return () => clearInterval(iv);
  }, [stepIdx, steps]);

  // Avanza los pasos
  useEffect(() => {
    const perStep = 2800 / steps.length;
    let current = 0;
    const iv = setInterval(() => {
      current++;
      setBarWidth((current / steps.length) * 100);
      if (current < steps.length) setStepIdx(current);
      else { clearInterval(iv); setDone(true); }
    }, perStep);
    return () => clearInterval(iv);
  }, [steps.length]);

  // Al terminar, pasa a la vista previa
  useEffect(() => {
    if (!done) return undefined;
    const t = setTimeout(() => navigate(dest, { state: passState, replace: true }), 600);
    return () => clearTimeout(t);
  }, [done, dest, navigate, passState]);

  return (
    <MarcoMarca pantalla="carga">
      <div className="gh-panel gw-panel" data-fase="charla">
        <LoadingDots size={10} />
        <h1 className="gw-texto" aria-live="polite">{displayText}</h1>
        <div className="gw-barra" role="progressbar" aria-label="Preparando tu web" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(barWidth)}>
          <div className="gw-barra__relleno" style={{ width: `${barWidth}%` }} />
        </div>
      </div>
    </MarcoMarca>
  );
};

export default GuiaLoading;
